import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Subpartners } from '../subpartners/types/index';
import { Notifications } from './types/index';

const routes: RouteConfig[] = [
  {
    path: `/${Notifications.Pages.NOTIFICATIONS}`,
    name: Notifications.Pages.NOTIFICATIONS,
    component: () => import(/* webpackChunkName: "notifications" */ './views/Notifications.vue'),
    meta: {
      access_roles: RouteRoles[Notifications.Pages.NOTIFICATIONS],
    },
  },

  {
    path: `/${Notifications.Pages.NOTIFICATIONS}/${Notifications.Pages.SETTINGS}`,
    name: Notifications.Pages.NOTIFICATIONS_SETTINGS,
    component: () => import(/* webpackChunkName: "notifications" */ './views/NotificationsSettings.vue'),
    meta: {
      access_roles: RouteRoles[Notifications.Pages.NOTIFICATIONS_SETTINGS],
    },
  },
];

export default routes;
